// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.producto-row {
  display: grid;
  grid-template-columns: 180px 1fr;
  grid-template-rows: auto auto;
  column-gap: 20px;
  align-items: center;
  margin: 20px auto;      /* Margen vertical y centrado horizontal */
  max-width: 600px;       /* Ajusta a tu gusto el ancho máximo para que no sea muy ancho */
  padding: 10px;
  box-sizing: border-box; /* Para que el padding no aumente el ancho */
  border: 1px solid #ddd; /* Opcional, para que se vea el recuadro del producto */
  border-radius: 8px;     /* Opcional, esquinas redondeadas */
  background-color: #fafafa; /* Opcional, fondo claro */
}

.producto-imagen {
  grid-column: 1 / 2;
  grid-row: 1 / 3; /* Ocupa dos filas */
  width: 170px;
  height: 170px;
  object-fit: cover;
  border-radius: 10px;
  box-shadow: 0 3px 6px rgba(0,0,0,0.2);
}

.producto-info {
  grid-column: 2 / 3;
  grid-row: 1 / 2;
  text-align: left;
  font-size: 18px;
}

.producto-actions {
  grid-column: 2 / 3;
  grid-row: 2 / 3;
  display: flex !important;
  gap: 12px;
  justify-content: flex-start !important;
}


.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* .info-compra {
  display: flex;
  flex-direction: row;
  align-items: center;
  white-space: nowrap;
} */

.info-compra {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  display: flex;
  gap: 10px;
  flex-wrap: nowrap;
  align-items: center;
  flex-direction: row; /* ya lo tenías */
}

@media (max-width: 768px) {

  .ocultar-en-movil {
    display: none;
  }

  .info-compra-modificar {
    display: flex;   
    flex-direction: column;
    align-items: flex-start; 
    white-space: normal !important;
    text-align: left;
  }

  .category, .subcategory {
    margin-left: 0 !important;
    margin-right: 0 !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
    width: 100% !important;  /* Que ocupen todo el ancho */
  }

  /* También elimina padding/margin en el contenedor general (si tiene) */
  .admin-gestion-productos-container {
    padding-left: 0 !important;
    padding-right: 0 !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
    width: 100% !important;
  }


  .producto-row {
    display: grid !important;
    grid-template-columns: 130px 1fr;
    grid-template-rows: auto auto;
    column-gap: 20px;
    align-items: center;
    justify-content: center !important;
    margin-left: auto;
    margin-right: auto;
    text-align: left;
  }


  .producto-imagen {
    grid-column: 1 / 2;
    grid-row: 1 / 3;
    width: 120px;
    height: 120px;
    object-fit: cover;
    border-radius: 10px;
    box-shadow: 0 3px 6px rgba(0,0,0,0.2);
    margin-left: 0; /* Elimina margen automático si hubiera */
  }

  .producto-info {
    grid-column: 2 / 3;
    grid-row: 1 / 2;
    text-align: left;
    font-size: 18px;
    margin-left: 0; /* Para asegurar que no haya margen que empuje a la derecha */
  }

  .producto-actions {
    grid-column: 2 / 3;
    grid-row: 2 / 3;
    display: flex !important;
    gap: 12px;
    justify-content: flex-start !important; /* botones a la izquierda */
  }

  table td,
  table th {
    padding: 16px 12px;
    font-size: 14px;
  }

  table tbody tr {
    line-height: 1.8;
    border-bottom: 1px solid #ccc;
  }

  table tbody tr:last-child {
    border-bottom: none;
  }
  
  .boton-movil-filtros {
    display: block !important;
  }
}


`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,6BAA6B;EAC7B,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB,OAAO,0CAA0C;EAClE,gBAAgB,QAAQ,gEAAgE;EACxF,aAAa;EACb,sBAAsB,EAAE,4CAA4C;EACpE,sBAAsB,EAAE,uDAAuD;EAC/E,kBAAkB,MAAM,mCAAmC;EAC3D,yBAAyB,EAAE,0BAA0B;AACvD;;AAEA;EACE,kBAAkB;EAClB,eAAe,EAAE,oBAAoB;EACrC,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,wBAAwB;EACxB,SAAS;EACT,sCAAsC;AACxC;;;AAGA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;;;;;GAKG;;AAEH;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB,EAAE,iBAAiB;AACxC;;AAEA;;EAEE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,8BAA8B;IAC9B,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,0BAA0B;IAC1B,0BAA0B;IAC1B,2BAA2B;IAC3B,sBAAsB,GAAG,6BAA6B;EACxD;;EAEA,uEAAuE;EACvE;IACE,0BAA0B;IAC1B,2BAA2B;IAC3B,yBAAyB;IACzB,0BAA0B;IAC1B,sBAAsB;EACxB;;;EAGA;IACE,wBAAwB;IACxB,gCAAgC;IAChC,6BAA6B;IAC7B,gBAAgB;IAChB,mBAAmB;IACnB,kCAAkC;IAClC,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;;;EAGA;IACE,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,qCAAqC;IACrC,cAAc,EAAE,yCAAyC;EAC3D;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,cAAc,EAAE,6DAA6D;EAC/E;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,wBAAwB;IACxB,SAAS;IACT,sCAAsC,EAAE,2BAA2B;EACrE;;EAEA;;IAEE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,6BAA6B;EAC/B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[".App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.producto-row {\n  display: grid;\n  grid-template-columns: 180px 1fr;\n  grid-template-rows: auto auto;\n  column-gap: 20px;\n  align-items: center;\n  margin: 20px auto;      /* Margen vertical y centrado horizontal */\n  max-width: 600px;       /* Ajusta a tu gusto el ancho máximo para que no sea muy ancho */\n  padding: 10px;\n  box-sizing: border-box; /* Para que el padding no aumente el ancho */\n  border: 1px solid #ddd; /* Opcional, para que se vea el recuadro del producto */\n  border-radius: 8px;     /* Opcional, esquinas redondeadas */\n  background-color: #fafafa; /* Opcional, fondo claro */\n}\n\n.producto-imagen {\n  grid-column: 1 / 2;\n  grid-row: 1 / 3; /* Ocupa dos filas */\n  width: 170px;\n  height: 170px;\n  object-fit: cover;\n  border-radius: 10px;\n  box-shadow: 0 3px 6px rgba(0,0,0,0.2);\n}\n\n.producto-info {\n  grid-column: 2 / 3;\n  grid-row: 1 / 2;\n  text-align: left;\n  font-size: 18px;\n}\n\n.producto-actions {\n  grid-column: 2 / 3;\n  grid-row: 2 / 3;\n  display: flex !important;\n  gap: 12px;\n  justify-content: flex-start !important;\n}\n\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* .info-compra {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  white-space: nowrap;\n} */\n\n.info-compra {\n  width: 100%;\n  overflow: hidden;\n  white-space: nowrap;\n  display: flex;\n  gap: 10px;\n  flex-wrap: nowrap;\n  align-items: center;\n  flex-direction: row; /* ya lo tenías */\n}\n\n@media (max-width: 768px) {\n\n  .ocultar-en-movil {\n    display: none;\n  }\n\n  .info-compra-modificar {\n    display: flex;   \n    flex-direction: column;\n    align-items: flex-start; \n    white-space: normal !important;\n    text-align: left;\n  }\n\n  .category, .subcategory {\n    margin-left: 0 !important;\n    margin-right: 0 !important;\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n    width: 100% !important;  /* Que ocupen todo el ancho */\n  }\n\n  /* También elimina padding/margin en el contenedor general (si tiene) */\n  .admin-gestion-productos-container {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n    margin-left: 0 !important;\n    margin-right: 0 !important;\n    width: 100% !important;\n  }\n\n\n  .producto-row {\n    display: grid !important;\n    grid-template-columns: 130px 1fr;\n    grid-template-rows: auto auto;\n    column-gap: 20px;\n    align-items: center;\n    justify-content: center !important;\n    margin-left: auto;\n    margin-right: auto;\n    text-align: left;\n  }\n\n\n  .producto-imagen {\n    grid-column: 1 / 2;\n    grid-row: 1 / 3;\n    width: 120px;\n    height: 120px;\n    object-fit: cover;\n    border-radius: 10px;\n    box-shadow: 0 3px 6px rgba(0,0,0,0.2);\n    margin-left: 0; /* Elimina margen automático si hubiera */\n  }\n\n  .producto-info {\n    grid-column: 2 / 3;\n    grid-row: 1 / 2;\n    text-align: left;\n    font-size: 18px;\n    margin-left: 0; /* Para asegurar que no haya margen que empuje a la derecha */\n  }\n\n  .producto-actions {\n    grid-column: 2 / 3;\n    grid-row: 2 / 3;\n    display: flex !important;\n    gap: 12px;\n    justify-content: flex-start !important; /* botones a la izquierda */\n  }\n\n  table td,\n  table th {\n    padding: 16px 12px;\n    font-size: 14px;\n  }\n\n  table tbody tr {\n    line-height: 1.8;\n    border-bottom: 1px solid #ccc;\n  }\n\n  table tbody tr:last-child {\n    border-bottom: none;\n  }\n  \n  .boton-movil-filtros {\n    display: block !important;\n  }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
